import { Flex } from 'antd';
import { ArrowRight } from '../icons';
import { Text } from '../Ant';
import { activationProps } from '../common/activationProps';
import { CardWrapper } from '../../assets/styles/components/notificationPopover.styled';

interface NotificationCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  time: string;
  isHighPriority?: boolean;
  onClick?: () => void;
}

const NotificationCard = ({
  icon,
  title,
  description,
  time,
  isHighPriority = false,
  onClick,
}: NotificationCardProps) => {
  return (
    <CardWrapper
      $isHighPriority={isHighPriority}
      data-testid="notification-card"
      {...(onClick && activationProps(onClick))}
    >
      <Flex gap={12} align="flex-start" className="w-full">
        <div className="icon-wrapper">{icon}</div>
        <Flex gap={5} vertical className="min-w-0 w-full">
          <Flex justify="space-between" align="center" gap={8}>
            <Text
              $fontsize="14px"
              $color="title"
              $weight={500}
              $lineheight="18px"
              className="lineclamp-2"
              data-testid="notification-title"
            >
              {title}
            </Text>
            <Flex align="center" gap={8}>
              <Text
                data-testid="notification-time"
                $fontsize="12px"
                $color="subtitle"
                $lineheight="20px"
              >
                {time}
              </Text>
              {isHighPriority && (
                <div className="priority-dot" data-testid="notification-priority-dot" />
              )}
            </Flex>
          </Flex>
          <Flex>
            <Text
              data-testid="notification-description"
              $fontsize="12px"
              $color="subtitle"
              className="lineclamp-2"
            >
              {description}
            </Text>
            <ArrowRight className="arrow-icon" />
          </Flex>
        </Flex>
      </Flex>
    </CardWrapper>
  );
};

export default NotificationCard;
